import { render } from "./PhoneProducts.vue?vue&type=template&id=04c5d4bf"
import script from "./PhoneProducts.vue?vue&type=script&lang=js"
export * from "./PhoneProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__